<template>
  <el-form ref="artist" :model="socials">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="Website" prop="website">
          <el-input type="text" v-model="socials.website" clearable />
        </el-form-item>
        <el-form-item label="Music video" prop="youtube_video">
          <el-input type="text" v-model="socials.youtube_video" clearable />
        </el-form-item>
        <el-form-item label="Music video" prop="music_video_2">
          <el-input type="text" v-model="socials.music_video_2" clearable />
        </el-form-item>
        <el-form-item label="Music video" prop="music_video_3">
          <el-input type="text" v-model="socials.music_video_3" clearable />
        </el-form-item>
        <el-form-item label="Music video" prop="music_video_4">
          <el-input type="text" v-model="socials.music_video_4" clearable />
        </el-form-item>                        
        <el-form-item label="YouTube channel" prop="youtube_channel">
          <el-input type="text" v-model="socials.youtube_channel" clearable />
        </el-form-item>
        <el-form-item label="Instagram" prop="instagram">
          <el-input type="text" v-model="socials.instagram" clearable />
        </el-form-item>
        <el-form-item label="Facebook" prop="facebook">
          <el-input type="text" v-model="socials.facebook" clearable />
        </el-form-item> 
        <el-form-item label="TikTok" prop="tiktok">
          <el-input type="text" v-model="socials.tiktok" clearable />
        </el-form-item>               
      </el-col>
      <el-col :span="12">
        <el-form-item label="Spotify" prop="spotify">
          <el-input type="text" v-model="socials.spotify" clearable />
        </el-form-item>        
        <el-form-item label="Apple Music" prop="apple_music">
          <el-input type="text" v-model="socials.apple_music" clearable />
        </el-form-item>
        <el-form-item label="Amazon" prop="amazon">
          <el-input type="text" v-model="socials.amazon" clearable />
        </el-form-item>
        <el-form-item label="Deezer" prop="deezer">
          <el-input type="text" v-model="socials.deezer" clearable />
        </el-form-item>
        <el-form-item label="SoundCloud" prop="soundcloud">
          <el-input type="text" v-model="socials.soundcloud" clearable />
        </el-form-item>
        <el-form-item label="Twitter" prop="twitter">
          <el-input type="text" v-model="socials.twitter" clearable />
        </el-form-item>
        <el-form-item label="Bandcamp" prop="bandcamp">
          <el-input type="text" v-model="socials.bandcamp" clearable />
        </el-form-item>
        <el-form-item label="Other" prop="other">
          <el-input type="text" v-model="socials.other" clearable />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('newReleasesArtists', ['socials', 'artist_id'])
  },

  methods: {
    ...mapActions('newReleasesArtists', ['readSocials'])
  },

  created() {
    if (this.artist_id !== null)
      this.readSocials(this.artist_id)
  }
}
</script>
